export function ImgTimeTaken({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9,24H1a1,1,0,0,1,0-2H9a1,1,0,0,1,0,2Z
               M7,20H1a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z
               M5,16H1a1,1,0,0,1,0-2H5a1,1,0,0,1,0,2Z
               M13,23.955a1,1,0,0,1-.089-2A10,10,0,1,0,2.041,11.09a1,1,0,0,1-1.992-.18A12,12,0,0,1,24,12,11.934,11.934,0,0,1,13.09,23.951C13.06,23.954,13.029,23.955,13,23.955Z
               M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z" />
    </svg>
  );
}